import type { FeedbackMessages } from './en';

const ms: FeedbackMessages = {
  qualified: {
    title: 'Terima kasih kerana melengkapkan kajian ini!',
    body1: 'Anda boleh menutup tetingkap pelayar ini sekarang.',
    body2: 'Kami berharap dapat bertemu anda lagi tidak lama lagi.',
    refCode: 'Kod Rujukan: {code}',
  },
  quotaFull: {
    title: 'Kajian ini telah ditutup',
    body1: 'Terima kasih atas minat anda terhadap kajian kami.',
    body2: 'Malangnya kami telah menerima semua maklum balas yang diperlukan.',
    body3: 'Kami berharap dapat bertemu anda dalam salah satu kajian kami pada masa hadapan!',
    refCode: 'Kod Rujukan: {code}',
  },
  terminated: {
    title: 'Terima kasih atas maklum balas anda!',
    body1:
      'Kami berharap dapat bertemu anda lagi dalam kajian kami pada masa hadapan. Sementara itu, kami mengucapkan selamat sejahtera.',
    body2: 'Sila tutup tetingkap pelayar ini.',
    refCode: 'Kod Rujukan: {code}',
  },
  mismatch: {
    title: 'Terima kasih atas minat anda',
    body1: 'Malangnya, anda tidak termasuk dalam kumpulan sasaran bagi kajian khusus ini.',
    body2: 'Anda boleh menutup halaman ini.',
    code: 'Kod: {code}',
  },
  error: {
    title: 'Kami tidak dapat memproses permintaan anda',
    linkProblemDetailed:
      'Pautan yang anda ikuti mengalami masalah. Sila semak sama ada pautan pada bar alamat sepadan dengan yang diberikan kepada anda, dan cuba lagi.',
    linkProblemGeneric: 'Pautan yang anda ikuti mengalami masalah. Sila cuba lagi.',
    contactPerson:
      'Jika masalah ini berterusan, sila maklumkan perkara ini kepada orang yang memberikan pautan tersebut kepada anda.',
    errorCode: 'Kod Ralat: {code}',
  },
};

export default ms;
